export const world = new World();
export const ECS = createReactAPI(world);
